import React from 'react'
import styled from 'styled-components'
import { AttachedFile, AttachedLink } from 'components/apply/attachments'
import { BsFillFileEarmarkFill } from 'react-icons/bs'
import { WithIdLink } from 'types/common'
import { Row } from 'components/common/layout'
import { AttachmentBlurWrapper } from 'components/scouts/common/attachment-blur-wrapper'
import { HiOutlineLink } from 'react-icons/hi'

export const FileWithIcon: React.FC<{
  file: WithIdLink
  iconSize?: number
  isAccessible?: boolean
}> = ({ file, iconSize = 35, isAccessible = true }) => {
  return (
    <AttachmentWrapper>
      <IconWrapper size={iconSize}>
        <BsFillFileEarmarkFill size={iconSize / 1.8} />
      </IconWrapper>
      <AttachmentBlurWrapper isAccessible={isAccessible}>
        <AttachedFile file={file.link} />
      </AttachmentBlurWrapper>
    </AttachmentWrapper>
  )
}

export const LinkWithIcon: React.FC<{
  link: WithIdLink
  iconSize?: number
  isAccessible?: boolean
}> = ({ link, iconSize = 35, isAccessible = true }) => {
  return (
    <AttachmentWrapper>
      <IconWrapper size={iconSize}>
        <HiOutlineLink size={iconSize / 1.8} />
      </IconWrapper>
      <AttachmentBlurWrapper isAccessible={isAccessible}>
        <AttachedLink link={link.link} />
      </AttachmentBlurWrapper>
    </AttachmentWrapper>
  )
}

const IconWrapper = styled(Row)<{ size: number }>`
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  justify-content: center;
  border-radius: 100px;
  background-color: #f4f4f4;
`

const AttachmentWrapper = styled(Row)`
  gap: 16px;
  height: 42px;
`
